import React from 'react';
import { Hero } from './components/Hero';
import { Dolor } from './components/Dolor';
import { Mecanismo } from './components/Mecanismo';
import { ParaQuienEs } from './components/ParaQuienEs';
import { VideoDemo } from './components/VideoDemo';
import { VideoInterior } from './components/VideoInterior';
import { Comparativa } from './components/Comparativa';
import { QueIncluye } from './components/QueIncluye';
import { ValorPercibido } from './components/ValorPercibido';
import { Beneficios } from './components/Beneficios';
import { Testimonios } from './components/Testimonios';
import { FAQ } from './components/FAQ';
import { OfertaFinal } from './components/OfertaFinal';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
import { UpsellProvider } from './components/UpsellContext';
export function App() {
  return <UpsellProvider data-id="element-0">
      <main className="min-h-screen bg-cream font-sans selection:bg-yellow/40 selection:text-violet" data-id="element-1">
        <Hero data-id="element-2" />
        <Dolor data-id="element-3" />
        <Mecanismo data-id="element-4" />
        <ParaQuienEs data-id="element-5" />
        <VideoDemo data-id="element-6" />
        <QueIncluye data-id="element-7" />
        <VideoInterior data-id="element-8" />
        <Comparativa data-id="element-9" />
        <Beneficios data-id="element-10" />
        <Testimonios data-id="element-11" />
        <ValorPercibido data-id="element-12" />
        <FAQ data-id="element-13" />
        <OfertaFinal data-id="element-14" />
        <Footer data-id="element-15" />
        <StickyCTA data-id="element-16" />
      </main>
    </UpsellProvider>;
}